import angular from 'angular';

// module imports
import analyticsDashboards from './analyticsDashboards.module';
import analyticsVisualizations from './analyticsVisualizations.module';
import analyticsCustomReports from './analyticsCustomReports.module';

export default angular
    .module('app.analytics', [analyticsDashboards, analyticsVisualizations, analyticsCustomReports])
    .name;